export const config = {
  graphQL: process.env.REACT_APP_GRAPHQL,
  graphQL2022: process.env.REACT_APP_GRAPHQL_2022,
  resultsUrl: process.env.REACT_APP_RESULTS_URL,
  enrollUrl: process.env.REACT_APP_ENROLL_URL,
}
